export default defineAppConfig({
	ui: {
		colors: {
			primary: 'neutral',
			neutral: 'gray',
		},
	},
})
